import React, { useState, useCallback, useEffect, useReducer, useLayoutEffect } from 'react'
import { StyleSheet, Text, View, ScrollView, Button, Alert, ActivityIndicator, Platform, KeyboardAvoidingView, Image } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import * as userActions from '../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import Input from '../components/Input';
import Card from '../components/Card';
import * as authActions from '../store/authActions';
import HeaderButton from '../components/HeaderButton';
import { HeaderButtons, Item } from 'react-navigation-header-buttons';
import {Ionicons} from '@expo/vector-icons'
import { TouchableOpacity } from 'react-native-gesture-handler';
import BottomLogo from '../components/BottomLogo';

const FORM_INPUT_UPDATE = 'FORM_INPUT_UPDATE';

 const formReducer = (state, action) => {
  if (action.type === FORM_INPUT_UPDATE) {
    const updatedValues = {
      ...state.inputValues,
      [action.input]: action.value
    };
    const updatedValidities = {
      ...state.inputValidities,
      [action.input]: action.isValid
    };
    let updatedFormIsValid = true;
    for (const key in updatedValidities) {
      updatedFormIsValid = updatedFormIsValid && updatedValidities[key];
    }
    return {
      formIsValid: updatedFormIsValid,
      inputValidities: updatedValidities,
      inputValues: updatedValues
    };
  }
  return state;
}; 

const HomeScreen = props => {
    const [error, setError] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showInfo, setShowInfo] = useState(Platform.OS === 'web' ? true : false);
    const [webError, setWebError] = useState();
    const [webSucces, setWebSucces] = useState();

    const userEmail = props.navigation.getParam('userEmail');

    const userInfo = useSelector(state => state.userdata);
    const isVerified = useSelector(state => state.auth.isVerified)

    const [formState, dispatchFormState] = useReducer(formReducer, {
        inputValues: {
          name: userInfo.userData.name ? userInfo.userData.name : '',
          emailAddress: userEmail ? userEmail : userInfo.userData.emailaddress,
          message: userInfo.userData.message ? userInfo.userData.message : '',
          emailAddressRecipient: userInfo.userData.emailaddressRecipient ? userInfo.userData.emailaddressRecipient : '',
        },
        inputValidities: {
          name: userInfo.userData.name ? true : false,
          emailAddress: true,
          message: userInfo.userData.message ? true : false,
          emailAddressRecipient: userInfo.userData.emailaddressRecipient ? true : false,
        },
        formIsValid: userInfo.userData.name ? true : false
    });


    const dispatch = useDispatch();

    const loadData = useCallback(async () => {
        setError(null);
        try {
            await dispatch(userActions.fetchData());
        } catch (err) {
            setError(err.message)
        }
    }, [dispatch, setError]);

    useEffect(() => {
        props.navigation.setParams({ logout: logoutHandler, changePassword: changePasswordHandler });
      }, [logoutHandler]);

    useEffect(() => {
        const willFocusSub = props.navigation.addListener('willFocus', loadData)

       return () => {
           willFocusSub.remove();
       };
   }, [loadData])

   useEffect(() => {
    setIsLoading(true);
    loadData().then(() => {
        setIsLoading(false);
    });
    }, [dispatch, loadData]);

    useEffect(() => {
      if(!!userInfo.userData.name) {
        inputChangeHandler('name', userInfo.userData.name, true)
        inputChangeHandler('emailAddress', userInfo.userData.emailaddress, true)
        inputChangeHandler('message', userInfo.userData.message, true)
        inputChangeHandler('emailAddressRecipient', userInfo.userData.emailaddressRecipient, true)
      }
    }, [userInfo])


    const submitHandler = useCallback(async () => {
        if (!formState.formIsValid) {
            if (Platform.OS === 'web') {
              setWebError(true)
            } else {
              Alert.alert('Wrong input', 'Please check the errors in the form.', [
                { text: 'OK'}
              ]);
            }
            return;
          }
        setError(null);
        setIsLoading(true);
        setWebError(null);
        try {
            if (userInfo.userData.name) {
                await dispatch(userActions.updateData(
                    userInfo.userData.id,
                    formState.inputValues.name,
                    formState.inputValues.emailAddress,
                    formState.inputValues.message,
                    formState.inputValues.emailAddressRecipient,
                    new Date()
            )
        );
            } else {
                await dispatch(userActions.setData(
                    formState.inputValues.name,
                    formState.inputValues.emailAddress,
                    formState.inputValues.message,
                    formState.inputValues.emailAddressRecipient,
                    new Date(),
                    'Y',
                    'N'
            )
        );
            }
        } catch (err) {
          setError(err.message);
        }
        setIsLoading(false)
        if (Platform.OS === 'web') {
          setWebSucces(true)
        } else {
          if (!isVerified) {
            Alert.alert('Succes', 'You have confirmed that you are alive. You do not have to do anything right now. We will remind you one month from now to confirm again through email. You can close the app.', [{text: 'OK'}])
          } else {
            Alert.alert('Please Note', 'Although you have confirmed that you are alive, you have not yet confirmed your email address. Please do so to use the service.', [{text: 'Understood', style: 'destructive'}],)
          }
          
        }
      }, [dispatch, formState, userInfo]);

    
    const inputChangeHandler = useCallback(
        (inputIdentifier, inputValue, inputValidity) => {
          dispatchFormState({
            type: FORM_INPUT_UPDATE,
            value: inputValue,
            isValid: inputValidity,
            input: inputIdentifier
          });
        },
        [dispatchFormState]
    );


    const logoutHandler = () => {
        dispatch(authActions.logout())
        // props.navigation.navigate('Auth')
    };

    const changePasswordHandler = () => {
        props.navigation.navigate('ChangePassword')
    };


    if (isLoading) {
        return (
        <View style={styles.activityIndicator}>
            <ActivityIndicator size='large' color={'black'} />
        </View>)
    }

    
    return (
        <KeyboardAvoidingView contentContainerStyle={{flex:1}} behavior="padding" style={{flex:1}} keyboardVerticalOffset={-220} >
          <ScrollView>
            <StatusBar style="auto" />
            <View style={{alignItems: 'center'}}>
            <View style={styles.formContainer}>
              <Card style={styles.card}>
                {isVerified && 
                <Text style={styles.verifyError}>This account is not yet verified. Please check your email inbox to start using FromHereAfter.</Text>}
                <Input
                    id="name"
                    label="Name"
                    errorText="Name field cannot be empty"
                    keyboardType="default"
                    autoCapitalize="words"
                    autoCorrect={false}
                    returnKeyType="next"
                    textContentType="name"
                    onInputChange={inputChangeHandler}
                    initialValue={userInfo.userData.name ? userInfo.userData.name : ''}
                    initiallyValid={!!(userInfo.userData.name)}
                    required
                    placeholder="Enter your full name"
                />
                <Input
                    id="emailAddress"
                    label="Your Email Address"
                    errorText="Please enter a valid email address"
                    keyboardType="email-address"
                    autoCapitalize="none"
                    autoCorrect={false}
                    returnKeyType="next"
                    textContentType="emailAddress"
                    onInputChange={inputChangeHandler}
                    initialValue={ userEmail ? userEmail : userInfo.userData.emailaddress}
                    initiallyValid={true}
                    required
                    email
                    editable={false}
                    style={{backgroundColor: '#f1f1f1'}}
                />
                <Input
                    id="message"
                    label="Message (To Recipient)"
                    errorText="Please enter a valid message"
                    keyboardType="default"
                    autoCapitalize="sentences"
                    numberOfLines={Platform.OS === 'web' ? 6 : 4}
                    autoCorrect={true}
                    multiline={true}
                    textAlignVertical='top'
                    minLength={4}
                    returnKeyType="next"
                    onInputChange={inputChangeHandler}
                    initialValue={userInfo.userData.message ? userInfo.userData.message : ''}
                    initiallyValid={!!(userInfo.userData.name)}
                    required
                    placeholder="Enter your confidential data here. This can be a password, a clue or anything. The content of this field will be send to your mentioned recipient if you do not confirm alive for longer than 37 days."
                />
                <Input
                    id="emailAddressRecipient"
                    label="Email Address Recipient"
                    errorText="Please enter a valid email address (different from your own)"
                    keyboardType="email-address"
                    autoCapitalize="none"
                    autoCorrect={false}
                    returnKeyType="next"
                    textContentType="emailAddress"
                    onInputChange={inputChangeHandler}
                    initialValue={userInfo.userData.emailaddressRecipient ? userInfo.userData.emailaddressRecipient : ''}
                    initiallyValid={!!(userInfo.userData.name)}
                    required
                    sameEmail={formState.inputValues.emailAddress}
                    email
                    placeholder="Enter the email of someone you trust"
                />
                  <View style={styles.lastdate}>
                      <View>
                          <Text style={styles.lastDateLabel}>Date Last Alive</Text>
                      </View>
                      <View style={styles.lastDateInput}>
                          <Text>{userInfo.userData.dateLastAlive ? new Date(userInfo.userData.dateLastAlive).toLocaleDateString() : ''}</Text>
                      </View>
                  </View>
                  <View style={styles.buttonContainer}>
                      <View><Button color="#404040" title="Save & Confirm Alive" onPress={submitHandler}  /></View>
                      {Platform.OS === 'web' ? <View></View> :
                      <TouchableOpacity style={styles.infoButton} onPress={ () => { showInfo ? setShowInfo(false) : setShowInfo(true)}}>
                          <Ionicons size={25} name={Platform.OS === 'android' ? 'md-information-circle-outline' : 'ios-information-circle-outline'} color="#585858" />
                      </TouchableOpacity>}
                  </View>
                  {webError &&<View style={{marginTop: 10}}>
                   <Text style={styles.errorText}>Wrong Input! Please check the form entries.</Text>
                  </View>}
                  {webSucces &&<View style={{marginTop: 10}}>
                   <Text style={styles.succesText}>Succes! You have confirmed that you are alive. We will remind you one month from now to confirm again through email. You can log out</Text>
                  </View>}
                  {showInfo && 
                  <View style={styles.infoText}>
                      <Text style={{color: '#404040'}}>Please enter your name and email address on this form. In the message field you can enter a message that you wish to bring to a person you trust. This message will only be sent to the person as identified in email address recipient if you fail to confirm alive.</Text>
                      <Text></Text>
                      <Text style={{color: '#404040'}}>Here is how you confirm alive: Press the 'Save & Confirm Alive' button. An email will be send to you a month after you signed up or a month after you last confirmed. This email will request you to confirm that you are still alive. Once you receive the mail, you have seven days to confirm. If you do not confirm within 7 days, the message in message field will be send to the specified emailaddress.</Text>
                  </View>}
              </Card> 
            </View>
            <BottomLogo style={{marginBottom: 50}} />
            </View>
          </ScrollView>
        </KeyboardAvoidingView>
    )
};

HomeScreen.navigationOptions = navData => {
    const logoutfn = navData.navigation.getParam('logout');
    const changePasswordfn = navData.navigation.getParam('changePassword')
    return {
        headerTitle: 'Home',
        headerLeft: (() =>
        <HeaderButtons HeaderButtonComponent={HeaderButton}>
          <Item
            title="Logout"
            iconName={
              Platform.OS === 'ios' ? 'ios-exit' : 'md-exit'
            }
            onPress={logoutfn}
          />
        </HeaderButtons>
      ),
      headerRight: (() =>
        <HeaderButtons HeaderButtonComponent={HeaderButton}>
          <Item
            title="Change Password"
            iconName={
              Platform.OS === 'ios' ? 'ios-key' : 'md-key'
            }
            onPress={changePasswordfn}
          />
        </HeaderButtons>
      )
    }   
}

export default HomeScreen

const styles = StyleSheet.create({
    screen: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center'
    },
    formContainer: {
        width: '90%',
        margin: 20,
    },
    lastdate: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 15,
        marginBottom: 35,
    },
    lastDateInput: {
        width: '40%',
        borderRadius: 5,
        paddingHorizontal: 4,
        paddingVertical: 7,
        alignItems: 'center',
        backgroundColor: '#e2e2e2',
        shadowColor: '#000',
        shadowOffset: {
          width: 0,
          height: 2,
        },
        shadowOpacity: 0.23,
        shadowRadius: 2.62,
        elevation: 4,
    },
    activityIndicator: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    card: {
        width: '100%',
        padding: 20,
        marginBottom: 20,
        
    },
    lastDateLabel: {
        fontSize: 14,
        color: '#585858',
        fontWeight: "bold"
    },
    buttonContainer: {
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    infoText: {
        marginTop: 10
    },
    errorText: {
      color: '#d9534f',
      fontSize: 15
    },
    succesText: {
      color: '#0275d8',
      fontSize: 17
    },
    verifyError: {
      color: "#f0ad4e"
    }
})


